// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Emotion from "../../bindings/Emotion.bs.js";
import * as JsxRuntime from "react/jsx-runtime";

function sizeValue(size) {
  if (size === "sm") {
    return "2.25rem";
  } else {
    return "2.5rem";
  }
}

function IconButton$IconButton(props) {
  let __className = props.className;
  let __disabled = props.disabled;
  let __size = props.size;
  let __variant = props.variant;
  let variant = __variant !== undefined ? __variant : "ghost";
  let size = __size !== undefined ? __size : "md";
  let disabled = __disabled !== undefined ? __disabled : false;
  let className = __className !== undefined ? __className : "";
  let dim = sizeValue(size);
  let variantStyles = variant === "ghost" ? Emotion.Css.css({
      backgroundColor: "transparent",
      color: Emotion.Utils.Color.textSecondary,
      ":hover": {
        backgroundColor: Emotion.Utils.Color.bgSecondary,
        color: Emotion.Utils.Color.textPrimary
      }
    }) : Emotion.Css.css({
      backgroundColor: Emotion.Utils.Color.primary,
      color: Emotion.Utils.Color.textInverse,
      ":hover": {
        backgroundColor: Emotion.Utils.Color.primaryDark
      }
    });
  return JsxRuntime.jsx("button", {
    children: props.children,
    "aria-label": props.label,
    className: Emotion.Css.cx([
      Emotion.Css.css({
        display: "grid",
        placeItems: "center",
        width: dim,
        height: dim,
        padding: "0",
        border: "none",
        borderRadius: Emotion.Utils.Border.getRadius("full"),
        cursor: "pointer",
        fontFamily: "inherit",
        fontSize: size === "sm" ? "0.875rem" : "1rem",
        transition: Emotion.Utils.Animate.getDuration("fast") + " ease-out",
        outline: "none",
        ":focus-visible": {
          boxShadow: Emotion.Utils.Shadow.getFocusShadow("primary")
        },
        ":disabled": {
          opacity: "0.5",
          cursor: "not-allowed"
        }
      }),
      variantStyles,
      className
    ]),
    disabled: disabled,
    type: "button",
    onClick: props.onClick
  });
}

let IconButton = {
  sizeValue: sizeValue,
  make: IconButton$IconButton
};

export {
  IconButton,
}
/* Emotion Not a pure module */
